import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

function RegisteredUsersChart({ data }) {
  return (
    <div className="wrapper">
      <header>
        <h2>Registered Users </h2>
      </header>
      <ResponsiveContainer height={300}>
        <AreaChart
          width={500}
          height={400}
          data={data}
          margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="key" />
          <YAxis />
          <Tooltip />
          <Area
            type="monotone"
            dataKey="value"
            stroke="#ff8f6b"
            fill="#fff4f0"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}

export default RegisteredUsersChart;
